// removed by extract-text-webpack-plugin
module.exports = {"ArticleListItem":"src-components-articles----article-list-module---ArticleListItem---1a426","ArticleListItem__icon":"src-components-articles----article-list-module---ArticleListItem__icon---15KAg","spinAround":"src-components-articles----article-list-module---spinAround---3j81c"};


//////////////////
// WEBPACK FOOTER
// ./src/components/articles/article-list.module.scss
// module id = 449
// module chunks = 35783957827783